export const SIDEBAR_WIDTH = 240;
export const NEW_FOLDER_ID = '__NEW__';
